<template>
    <!-- 输入管理员密码 -->
    <Modal class-name="vertical-center-modal" :value="showSetModel" :title="$t('BasicProduct.adminBox.title')" :footer-hide="true"
        :mask-closable="false" @on-cancel="handleCancel" :styles="{ 'min-width': '560px', 'max-height': '800px' }">

        <Form ref="formData"  :model="formData" :rules="ruleCustom"  :label-width="80">

            <FormItem :label="$t('BasicProduct.adminBox.password')" prop="password" style="width: 500px;">
                <Input type="password" v-model="formData.password" :placeholder="$t('inputPlaceholder')"></Input>
            </FormItem>

            <FormItem>
                <Button type="primary" :loading="loading" @click="handleSubmit('formData')">{{ $t('BasicProduct.adminBox.save')}}</Button>
                <Button @click="handleCancel" style="margin-left: 8px">{{ $t('cancel') }}</Button>
            </FormItem>
        </Form>


    </Modal>
</template>
<script>
export default {
    props: {
        showSetModel: Boolean,
        fn:Function,
        type:Number,
        loading:{
            type:Boolean,
            default:false
        }
    },
    name: "ModelAdime",
    data(){
        return {
            formData:{
                password:''
            },
            // disabled:false
        }
    },
    computed:{
        ruleCustom(){
                 return {//验证
                    password: [
                        {required: true, message: this.$t('required'),trigger: 'blur' }
                    ]
                }
             } 
    },
    watch:{
        showSetModel(val){
            if(val === false) {   
               
               this.resetForm()
              
            } 
        }
    },
    methods:{
        handleCancel(){
            this.$emit('update:showSetModel',false);
            this.resetForm()
        },
        handleSubmit(name){
            this.$refs[name].validate((valid) => {

                if (valid) {

                        // this.disabled = true
                        this.fn(this.formData.password)
            
                        // this.axios.post(url, params).then((result) => {
                            
                        //     common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                        //         this.resetForm();//重置表单
                                // this.fn(params)
                        //     },()=>{this.disabled = false})
                            
                        // })

                }
            })
               

        },
        resetForm(){
            this.$refs.formData.resetFields();//重置表单
            // this.disabled = false
        }

    }
}



</script>